export const DOMAIN_FOLDERS = "FOLDERS";
